"use strict";
$.fn.selectpicker.Constructor.BootstrapVersion = "5";
$.fn.selectpicker.Constructor.DEFAULTS.style = "";
$.fn.selectpicker.Constructor.DEFAULTS.styleBase = "form-control";
$.fn.selectpicker.Constructor.DEFAULTS.liveSearch = true;
$.fn.selectpicker.Constructor.DEFAULTS.showTick = true;
$.fn.selectpicker.Constructor.DEFAULTS.liveSearchNormalize = true;

$(function () {
    setupPicker(".form-picker", false);
    setupPicker(".form-picker-multiple", true);

    $(document).on("reset", "form", function (e) {
        $(".form-picker").selectpicker("val", null);
        $(".form-picker-multiple").selectpicker("val", null);
    });
});

/**
 * Permite aplicar Bootstrap-select a cualquier identificador clase o id
 * @param {object} obj Objeto de opciones
 * @param {string} obj.elemento clase o Id
 * @param {boolean} obj.validar si el formulario va a ser validado (opcional|true)
 * @param {boolean} obj.selectAllOption si el select va a tener la opción de seleccionar (opcional)
 */
function AplicarSelect(obj) {
    if (typeof obj === "undefined") {
        obj = {
            elemento: ".form-picker",
            validar: true,
            selectAllOption: false,
        };
    }
    setupPicker(obj.elemento, obj.selectAllOption, obj.validar);
}

/**
 * Crear el selector
 * @param {string} elemento Clase o Identificador elementos
 * @param {boolean} selectAllOption Si se va a presentar las opciones de seleccionar todo o ninguno
 *  cuando es selector multiple
 * @param {boolean} validar Si el formulario va a ser validado (opcional|true)
 */
function setupPicker(elemento, selectAllOption, validar) {
    if (typeof validar === "undefined") {
        validar = true;
    }
    let $element = $(elemento);
    $element.selectpicker({
        actionsBox: selectAllOption,
        width: '100%'
    });

    if (validar) {
        $(elemento).on("change", function () {
            let $this = $(this);
            if ($this.is("select") && $this.closest("form").length) {
                if (typeof $.validator != "undefined") {
                    $this.valid();
                }
            }
        });
    }
}
